import type { DomainError } from '@core/domain/errors';
import { ErrorCategory, getUserFriendlyMessage } from '@core/domain/errors';

/**
 * Network error interface
 */
interface NetworkErrorObject {
  networkError: {
    message?: string;
    [key: string]: unknown;
  };
}

/**
 * Type guard for network errors
 */
export function isNetworkError(error: unknown): boolean {
  return typeof error === 'object' && error !== null && 'networkError' in error && (error as NetworkErrorObject).networkError !== null;
}

/**
 * Adapts network errors to domain errors
 */
export function adaptNetworkError(error: unknown): DomainError {
  if (!isNetworkError(error)) {
    throw new Error('Not a network error');
  }

  const networkError = (error as NetworkErrorObject).networkError;

  const code = 'NETWORK_ERROR';

  return {
    code,
    message: networkError.message || 'Unable to connect to the server',
    userMessage: getUserFriendlyMessage(ErrorCategory.SERVICE, 'Unable to connect to the server', code),
    category: ErrorCategory.SERVICE,
    details: networkError,
  };
}
